export default __webpack_public_path__ + "static/media/2483.fd8e8269.png";